import axios from 'axios';

export const baseApi = '/api';
export const imgUrl = '';

export const api = axios.create({
    baseURL: baseApi,
    withCredentials: true,
})
